export const defaultPromotions = 'Default Promotions';
export const activePromotions = 'Active Promotions';
export const promotions = 'Promotions';
export const welcomeBonusType = 'FirstDeposit';
export const bonusItem = 'bonusItem';
export const bonusActiveItem = 'bonusActiveItem';
export const typeFixed = 'fixed';
export const typeDefault = 'default';
export const typeCancel = 'cancellation';
export const typeFirstDeposit = 'firstDeposit';
export const cashbackOnTotalStakeType = 'CashbackOnTotalStake';
export const mockWage = '43';
export const mockWageRequired = '50';
export const xApiKey = process.env.REACT_APP_MAGICX_API_KEY;
export const minDeposit = '10';
export const PROMOTION = 'promotion';

export const today = new Date().toISOString();
